import { ENV } from '../../config/runtimeEnv';
import { GeneOntology } from '../../types/geneCodes/GeneExpressionTypes';
import { http } from '../../lib/http/client';

const API_BASE_URL = ENV.VITE_LABIQ_SERVER || '';

// Helper for common API headers

/**
 * Fetch organ expression data for a specific gene
 */
export const fetchGeneOrganExpressions = async (geneName: string): Promise<Array<Record<string, number>>> => {
	try {
		const response = await http.get(`${API_BASE_URL}/gene-expression/organs/${geneName}`);
		return response.data;
	} catch (error) {
		console.error('Error fetching gene organ expressions:', error);
		throw error;
	}
};

/**
 * Fetch SVG body diagrams for visualization
 */
export const fetchBodySvgs = async (): Promise<{
	male_svg: string;
	female_svg: string;
	cell_svg: string;
}> => {
	try {
		const response = await http.get(`${API_BASE_URL}/gene-expression/svg-bodies`);
		return response.data;
	} catch (error) {
		console.error('Error fetching body SVGs:', error);
		throw error;
	}
};

/**
 * Fetch cellular location data for a specific gene
 */
export const fetchCellularLocations = async (geneName: string): Promise<any[]> => {
	try {
		const response = await http.get(`${API_BASE_URL}/gene-expression/cell-locations/${geneName}`);
		return response.data;
	} catch (error) {
		console.error('Error fetching cellular locations:', error);
		throw error;
	}
};

/**
 * Fetch Gene Ontology annotations for a specific gene, grouped by aspect
 */
export const fetchGeneOntology = async (geneName: string): Promise<GeneOntology> => {
	try {
		const response = await http.get(`${API_BASE_URL}/gene-expression/ontology/${geneName}`);
		return response.data;
	} catch (error) {
		console.error('Error fetching gene ontology:', error);
		throw error;
	}
};
